import { Component, ElementRef, Input, OnDestroy, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base/base-component.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConstants } from 'src/app/constants/constants';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-fs-player',
  templateUrl: './fs-player.component.html',
  styleUrls: ['./fs-player.component.scss']
})
export class FsPlayerComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() contentUrl: string;
  @ViewChild("iframe", { static: false }) iframe: ElementRef;

  constructor(public sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) { 
    super(); 
  }

  safeURL: SafeResourceUrl = undefined;
  ready: boolean = false;
  siteLanguageCode: string;
  url: string;

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.url = params.get(AppConstants.FS_PLAYER_FULL_PATH);
    });

    this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.getSanitizedUrl(this.url)
    );

    this.ready = true;
  }

  private getSanitizedUrl(path: string): string {
    return this.sanitizer.sanitize(
      SecurityContext.URL,
      path
    );
  }
}
